export const config_module = {
  momentum: {
    base_url: 'https://staging.api.pepperos.io',
    oauth_url: 'https://oauth2.staging-multi.pepperos.io',
    context: 'staging',
    recurlyUrl: 'https://js.recurly.com/v4/recurly.js',
    recurlyPublicKey: 'ewr1-ZeSnXhWp5gJqz0nHhEuX7m',
    configToken: 'cGVwcGVyTWV0YURhdGE6TGQmaW1wQW9UcnFp',
  },
  pepper: {
    base_url: 'https://staging.api.pepperos.io',
    oauth_url: 'https://oauth2.staging-multi.pepperos.io',
    context: 'staging',
    recurlyUrl: 'https://js.recurly.com/v4/recurly.js',
    recurlyPublicKey: 'ewr1-BSkoONxL11oD53d3N1TP2z',
    configToken: '077b69d04c5d423d8f048a1798b8474a',
    analytics: {
      provider: 'clevertap',
      config: {
        accountId: 'TEST-K5Z-56R-7R5Z',
      },
    },
    appStoreUrl: {
      android: 'https://play.google.com/store/apps/details?id=com.pepper.too&hl=en',
    },
  },
  otis: {
    base_url: 'https://staging.api.pepperos.io',
    oauth_url: 'https://oauth2.staging-multi.pepperos.io',
    context: 'staging',
    recurlyUrl: 'https://js.recurly.com/v4/recurly.js',
    recurlyPublicKey: 'ewr1-txfmldTNvCC9C5TZ4oHa6Z',
    configToken: 'cGVwcGVyTWV0YURhdGE6XlROWUNoWCFyXjcj',
  },
  visi: {
    base_url: 'https://staging.api.pepperos.io',
    oauth_url: 'https://oauth2.staging-multi.pepperos.io',
    context: 'staging',
    recurlyUrl: 'https://js.recurly.com/v4/recurly.js',
    recurlyPublicKey: 'ewr1-xGsOYfDwJh1rKpWJYYxPbA',
    configToken: 'cGVwcGVyTWV0YURhdGE6cjcmIUUrIW1uPGdMcnEoTA==',
  },
  geeni: {
    base_url: 'https://staging.api.pepperos.io',
    oauth_url: 'https://oauth2.staging-multi.pepperos.io',
    context: 'staging',
    recurlyUrl: 'https://js.recurly.com/v4/recurly.js',
    recurlyPublicKey: 'ewr1-6UN0NFBn9RXWj3ZqW0lFu7',
    ftmId: 'GTM-N5KLK68N',
    abTestScript: '5BXrxOUpYv^1',
    abTestBaseUrl: 'https://crsoptimizer.conversionrate.store/comp',
    recurlyGooglePay: {
      // These should correspond to values in API docs https://recurly.com/developers/reference/recurly-js/#google-pay-
      merchantId: 'TODO-SET-ME',
      environment: 'TEST',
    },
    paypalGatewayCode: 'wydf12e4c6cv',
    stripePublicKey:
      'pk_test_40DpPkZhqK69boNdC3ygyBgsCMGIzMq9rbRmeqBbD7ELUduU6gW4NcmKhvinbztWdiNVFfUfknl2OsCRDkFfVe7s7003wu2I6Mq',
    configToken: 'cGVwcGVyTWV0YURhdGE6SSMhUyZZUXlFZWpF',
    stripeAccountId: 'acct_1LkZQlIxsqGHDLj3',
    analytics: {
      provider: 'clevertap',
      config: {
        accountId: 'TEST-Z4R-8K7-756Z',
      },
    },
    social: {
      google: {
        clientId: '1060205334349-ptsrvmpukp13ku1834igtbs7morbcnjf.apps.googleusercontent.com',
      },
      apple: {
        redirectUriBase: 'https://staging.account.merkurysmart.com',
        lrUri: 'https://geeni-stag.hub.loginradius.com/RequestHandler.aspx',
        lrApiKey: '29dd96aa-0a57-4707-8e30-89da6fb0b504',
      },
    },
    appStoreUrl: {
      ios: 'https://apps.apple.com/us/app/geeni/id1177386276',
      android: 'https://play.google.com/store/apps/details?id=com.merkuryinnovations.geeni&hl=en',
    },
    // External API configuration for marketing scripts
    externalApi: {
      enabled: true, // Enabled for testing in staging
      allowedOrigins: [
        'https://staging.account.merkurysmart.com',
        'https://staging.merkurysmart.com',
        'https://dev.merkurysmart.com',
        'http://localhost:3000',
        'http://localhost:8080'
      ], // Include staging and dev domains
      rateLimitPerMinute: 40, // Moderate rate limit for staging
    },
  },
  notion: {
    base_url: 'https://staging.api.pepperos.io',
    oauth_url: 'https://oauth2.staging-multi.pepperos.io',
    context: 'staging',
    recurlyUrl: '',
    recurlyPublicKey: '',
    configToken: 'cGVwcGVyTWV0YURhdGE6NGh7TWViIik8Jms+VVBrUw==',
  },
  nightowl: {
    base_url: 'https://staging.api.pepperos.io',
    oauth_url: 'https://oauth2.staging-multi.pepperos.io',
    context: 'staging',
    recurlyUrl: 'https://js.recurly.com/v4/recurly.js',
    recurlyPublicKey: 'ewr1-uRacqSve3l448lnbIsHSuM',
    configToken: 'cGVwcGVyTWV0YURhdGE6WGE0IVNeXjYlNzNq',
    analytics: {
      provider: 'clevertap',
      config: {
        accountId: 'TEST-798-4WK-R96Z',
      },
    },
  },
};
